"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, ChevronDown, ChevronUp } from "lucide-react";
import logo from "../../../public/images/WebsiteImages/PandoForce_Logo-bg.png";
import Image from "next/image";
import MegaMenuPando from "./pandomegamenu";

const Header = ({ currentPage = "" }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSolutions, setShowSolutions] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleSolutions = () => setShowSolutions((prev) => !prev);

  const handleLoginClick = () => {
    window.location.href = "/auth/login";
  };

  const handleNavigateHome = () => {
    window.location.href = "/";
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#ebf2f0]">
      <div className="flex items-center justify-between py-2 px-6 h-14 mx-auto w-full">
        {/* Left: Logo */}
        <div className="h-8 flex items-center">
          <button onClick={handleNavigateHome}>
            <Image
              src={logo}
              alt="PandoForce Logo"
              width={140}
              height={32}
              className="object-contain"
            />
          </button>
        </div>

        {/* Center: Solutions */}
        <div className="flex-1 flex justify-center gap-12">
          <div className="relative">
            <button
              onClick={toggleSolutions}
              className={`flex items-center gap-1 font-medium ${
                showSolutions || currentPage === "solutions"
                  ? "text-primary"
                  : "text-gray-700 hover:text-primary"
              }`}
            >
              Solutions
            </button>

            {showSolutions && (
              <MegaMenuPando onClose={() => setShowSolutions(false)} />
            )}
          </div>
          <div className="flex gap-12">
            <a
              href="/pricing"
              className={`font-medium text-gray-700 hover:text-primary ${
                currentPage === "pricing" && !showSolutions
                  ? "text-primary"
                  : ""
              }`}
            >
              Pricing
            </a>
{/*             <a
              href="/pf-consultancy"
              className={`font-medium text-gray-700 hover:text-primary ${
                currentPage === "consultancy" && !showSolutions
                  ? "text-primary"
                  : ""
              }`}
            >
            Consultancy
            </a> */}
          </div>
        </div>

        {/* Right: Login */}
        <div>
          <Button
            variant="outline"
            className="text-white hover:bg-primary  bg-secondary  hover:text-white"
            onClick={handleLoginClick}
          >
            Login
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
